module.exports = __webpack_public_path__ + "static/media/worldMap.93c3faa5.topojson";